import React, { memo } from 'react';

import {
	FieldHeadingTitle,
	FieldHeading,
	FieldWrapper,
	SideBySideField,
} from '@atlassian/jira-issue-field-heading';
import { FieldPin } from '@atlassian/jira-issue-field-pin';
import IssueTeamField from '@atlassian/jira-issue-field-team';
import { isTeamFieldInSubtasksEnabled } from '../../feature-flags';
import type { Props } from './types';

export const View = (props: Props) => {
	const { label, issueKey, fieldId, issueId, isSubTask, onUpdate, noValueText, showPinButton } =
		props;

	// For the Teams in Jira EAP we want to hide the team field on subtasks when FF isTeamFieldInSubtasksEnabled is off
	if (isSubTask && !isTeamFieldInSubtasksEnabled()) {
		return null;
	}

	return (
		<FieldWrapper>
			<FieldHeading>
				<FieldHeadingTitle>{label}</FieldHeadingTitle>
				{showPinButton === true && <FieldPin fieldId={fieldId} label={label} />}
			</FieldHeading>
			<SideBySideField>
				<IssueTeamField
					label={label}
					issueKey={issueKey}
					issueId={issueId}
					fieldKey={fieldId}
					onUpdate={onUpdate}
					noValueText={noValueText}
					isFitContainerWidthReadView
				/>
			</SideBySideField>
		</FieldWrapper>
	);
};

export default memo<Props>(View);
